import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Icon } from "@iconify/react";

const PatientCard = ({ review }) => {
  const initial = (review?.name || "P")[0].toUpperCase();
  return (
    <div className="mx-3 w-72 flex-shrink-0 bg-white border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
      {/* Stars */}
      <div className="flex gap-0.5 mb-3">
        {[1, 2, 3, 4, 5].map((s) => (
          <Icon key={s} icon="solar:star-bold" className="w-3 h-3 text-amber-400" />
        ))}
      </div>

      {/* Quote mark */}
      <Icon icon="solar:quote-up-bold-duotone" className="w-5 h-5 text-indigo-100 mb-2" />

      {/* Text */}
      <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">
        {review?.review || review?.content || review?.message || "Amazing experience with Medmyne."}
      </p>

      {/* Footer */}
      <div className="flex items-center gap-3 mt-4 pt-4 border-t border-gray-50">
        {review?.image ? (
          <img
            src={review.image}
            alt={review.name}
            className="w-9 h-9 rounded-full object-cover border-2 border-indigo-100 flex-shrink-0"
          />
        ) : (
          <div className="w-9 h-9 rounded-full bg-brand-gradient flex items-center justify-center text-white text-sm font-bold font-heading flex-shrink-0">
            {initial}
          </div>
        )}
        <div>
          <p className="text-sm font-bold text-gray-900 font-heading leading-tight">
            {review?.name || "Anonymous"}
          </p>
          <p className="text-[10px] text-indigo-500 font-medium mt-0.5">
            {review?.designation || "Verified Patient"}
          </p>
        </div>
      </div>
    </div>
  );
};

const PatientReview = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/patientReview/getpatientReview`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setReviews(d.data); });
  }, []);

  return (
    <section className="section-py bg-[#fafafa] overflow-hidden">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14">
        <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-5">
          <Icon icon="solar:heart-bold" className="w-3.5 h-3.5" />
          Patient Stories
        </span>
        <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight">
          Our Happy Patients
        </h2>
        <p className="mt-5 text-base text-gray-500 max-w-xl mx-auto">
          Real stories from real people who trust Medmyne for their healthcare journey.
        </p>

        {/* Aggregate stars */}
        <div className="mt-5 inline-flex items-center gap-2 bg-white border border-gray-100 rounded-full px-5 py-2 shadow-sm">
          <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map(s => <Icon key={s} icon="solar:star-bold" className="w-4 h-4 text-amber-400" />)}
          </div>
          <span className="text-sm font-semibold text-gray-700">4.9 / 5.0</span>
          <span className="text-xs text-gray-400">from 500+ reviews</span>
        </div>
      </div>

      {reviews.length > 0 && (
        <Marquee
          pauseOnHover
          autoFill
          speed={30}
          gradient
          gradientColor={[250, 250, 250]}
          gradientWidth={120}
        >
          {reviews.map((r, i) => <PatientCard key={r?._id || i} review={r} />)}
        </Marquee>
      )}
    </section>
  );
};

export default PatientReview;
